import { Directive, ElementRef, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ValidatorBase } from '../core/model';
import { Validator } from '../core/model/validator';

@Directive({
  selector: '[email-validator]',
  host: { '(input)': 'onInput($event)', '(change)': 'changed($event)' },
  exportAs: 'validator'
})
export class EmailValidatorDirective extends ValidatorBase implements OnInit, Validator {
  @Input('email-validator')
  public getValue: () => string;

  private static _emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  public valid: boolean;

  @Input('depending-element') public dependingElement: ElementRef;
  @Input('allow-paste') public allowPaste: boolean;

  public constructor(viewRef: ViewContainerRef) {
    super(viewRef);
  }

  public changed(): void {
    this.validate();
  }

  public ngOnInit(): void {
    if (this.allowPaste === false) {
      this.elementRef.addEventListener('paste', (e) => { e.preventDefault(); });
    }
  }

  public onInput(): void {
    if (this.valid === false) {
      this.validate();
    }
  }

  protected isValid(): boolean {
    const value = this.elementRef.value;
    let valid = EmailValidatorDirective._emailRegex.test(value);

    if (!!this.dependingElement) {
      const dependingValue = this.dependingElement.nativeElement.value;
      valid = valid && (value.toLowerCase() === dependingValue.toLowerCase());
    }

    return valid;
  }
}
